// extracted by mini-css-extract-plugin
export default {"navigation":"styles_navigation__1RFbz","link":"styles_link__WIwta","active":"styles_active__bDZkb"};